import { app_download_link } from '@porterin/feature/src/containers/download-app/helpers/DownloadAnalyticsHelper';
import Link from 'next/link';
import React from 'react';

import { downloadNow } from '../store/PaymentSuccessStore';
import styles from '../styles/PaymentSuccessMobFooter.module.scss';

function PaymentSuccessMobFooterCmp(): React.ReactElement {
  return (
    <div className={styles['download-app-footer']}>
      <button className={styles['cta']}>
        <Link href={app_download_link}>{downloadNow}</Link>
      </button>
    </div>
  );
}

export default PaymentSuccessMobFooterCmp;
